import React, { useState } from "react";

import ApprovedContractorsListItem from "./ApprovedContractorsListItem.jsx";
import TableWrapper from "../shared/bootstrap/TableWrapper.jsx";
import TableHeaderColumn from "../shared/TableHeaderColumn.jsx";
import { approvedContractorListSortMap } from "../../util/sort.js";

import {
  SORT_SITE_NAME_ASC,
  SORT_SITE_NAME_DESC,
  SORT_CONTRACT_ASC,
  SORT_CONTRACT_DESC,
  SORT_CONTRACT_DATE_ASC,
  SORT_CONTRACT_DATE_DESC,
  SORT_SHORT_AGENCY_NAME_ASC,
  SORT_SHORT_AGENCY_NAME_DESC,
} from "../../constants.js";

export default function ApprovedContractorsList({ approvedContractorsListData }) {
  //init state
  const [sortOption, setSortOption] = useState(SORT_SITE_NAME_ASC);

  //define onClick handlers
  const setSiteNameSort = () => {
    setSortOption((prevState) => (prevState === SORT_SITE_NAME_ASC ? SORT_SITE_NAME_DESC : SORT_SITE_NAME_ASC));
  };
  const setContractSort = () => {
    setSortOption((prevState) => (prevState === SORT_CONTRACT_ASC ? SORT_CONTRACT_DESC : SORT_CONTRACT_ASC));
  };
  const setContractDateSort = () => {
    setSortOption((prevState) => (prevState === SORT_CONTRACT_DATE_ASC ? SORT_CONTRACT_DATE_DESC : SORT_CONTRACT_DATE_ASC));
  };
  const setShortAgencyNameSort = () => {
    setSortOption((prevState) => (prevState === SORT_SHORT_AGENCY_NAME_ASC ? SORT_SHORT_AGENCY_NAME_DESC : SORT_SHORT_AGENCY_NAME_ASC));
  };

  const tableContent = 
    <tbody key="approvedContractors" role="rowgroup">

      {approvedContractorsListData.sort(approvedContractorListSortMap[sortOption]).map((item) => (
        <ApprovedContractorsListItem key={item.id} approvedContractor={item} />
      ))}
    </tbody>;

  return (
    <TableWrapper
      id="approvedContractorsTable"
      summary="List of Approved Contractors"
      caption="List of approved contractors sorted by site name"
    >
      <thead role="rowgroup">
        <tr role="row">
          <TableHeaderColumn
            id="siteName-head"
            className="col-xs-6"
            text="Site Name (rollover to see address)"
            onClick={setSiteNameSort}
            title="site name"
            sortOption={sortOption}
            sortDesc={SORT_SITE_NAME_DESC}
          />

          <TableHeaderColumn
            id="contractNumber-head"
            className="col-xs-2 text-left"
            text="Federal Contract Number"
            onClick={setContractSort}
            title="federal contract number"
            sortOption={sortOption}
            sortDesc={SORT_CONTRACT_DESC}
          />

          <TableHeaderColumn
            id="contractDate-head"
            className="col-xs-2 text-left"
            text="Contract Period of Performance Date"
            onClick={setContractDateSort}
            title="contract date"
            sortOption={sortOption}
            sortDesc={SORT_CONTRACT_DATE_DESC}
          />

          <TableHeaderColumn 
            id="shortAgencyName-head" 
            className="col-xs-3 text-left" 
            text="Short Agency Name" 
            onClick={setShortAgencyNameSort}
            title="short agency name"
            sortOption={sortOption}
            sortDesc={SORT_SHORT_AGENCY_NAME_DESC}
          />
        </tr>
      </thead>
      {tableContent}
    </TableWrapper>
  );
}
